module.exports = __webpack_public_path__ + "media/images/ln/constellation_03-4cf1deb9a1ca99b9d94e1deae305622a.png";